module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"vacancy":"Job","step":"Step"}}')
  delete Component.options._Ctor
}
